import { faBinoculars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import type { ExternalVerification } from '@/types/externalVerification';
import Alert from '@/ui/components/Alert';

interface Props {
  mostRecentDiscovery: ExternalVerification;
  policiesCount: number;
}

const AutoDiscoveryBanner = ({ mostRecentDiscovery, policiesCount }: Props) => {
  const { requested_at } = mostRecentDiscovery;

  const formattedDate = requested_at
    ? new Date(requested_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    : 'Unknown date';

  return (
    <Alert level="info" dismissable={false}>
      <div className="flex items-center gap-2">
        <FontAwesomeIcon icon={faBinoculars} className="h-5 w-5 text-blue-800" />
        <p className="text-sm font-medium text-blue-800">
          Automated Discovery returned {policiesCount} {policiesCount === 1 ? 'policy' : 'policies'}{' '}
          on {formattedDate}
        </p>
      </div>
    </Alert>
  );
};

export default React.memo(AutoDiscoveryBanner);
